import s from './Chat.module.css'

export default function ErrorMessage({ msg }) {
  return <div className={`${s.message} ${s.errorMessage}`}>{msg}</div>
}
